module.exports = __webpack_public_path__ + "img/er_it.7cb0628e.png";